import { render, staticRenderFns } from "./video-signup.vue?vue&type=template&id=2d2f3471&scoped=true"
import script from "./video-signup.vue?vue&type=script&lang=ts"
export * from "./video-signup.vue?vue&type=script&lang=ts"
import style0 from "./video-signup.vue?vue&type=style&index=0&id=2d2f3471&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2f3471",
  null
  
)

export default component.exports